import * as React from 'react';
import { useRef } from 'react';
import { SearchInput } from './SearchHeaderBlocks/SearchInput';

interface SearchInputBlockProps {
  settings?: {
    placeholder_text?: string;
    search_results_event_name?: string;
    search_state_event_name?: string;
    search_clear_event_name?: string;
    enable_search_events?: boolean;
    search_events_to_trigger?: string;
    [key: string]: any;
  };
  className?: string;
}

export const SearchInputBlock: React.FC<SearchInputBlockProps> = ({ settings, className = '' }) => {
  const blockSettings = settings?.settings?.block_settings || settings || {};
  const searchInputRef = useRef<any>(null);

  console.log('Search input block settings', blockSettings);
  // Fire events when input is focused or clicked, if enabled
  const handleOpenSearch = () => {
    if (blockSettings.enable_search_events !== false) {
      console.log('Clicked search events');
      let events = ['header-search-toggle', 'search-opened'];
      if (typeof blockSettings.search_events_to_trigger === 'string' && blockSettings.search_events_to_trigger.trim()) {
        events = blockSettings.search_events_to_trigger.split(',').map(e => e.trim()).filter(Boolean);
      }
      events.forEach(eventName => {
        window.dispatchEvent(new CustomEvent(eventName));
      });
    }
  };

  const handleSearch = (query: string) => {
    // Dispatch search state event
    if (blockSettings.search_state_event_name) {
      window.dispatchEvent(new CustomEvent(blockSettings.search_state_event_name, {
        detail: { query }
      }));
    }

    // Dispatch search request event
    const searchRequestEvent = new CustomEvent('searchrequest', {
      detail: {
        query: query,
        type: 'header-search',
        page: 1,
        productsPerPage: 24,
        sort: 'RELEVANCE',
        direction: 'DESC',
        filters: []
      }
    });

    window.dispatchEvent(searchRequestEvent);
  };

  return (
    <div className={`w-full ${className}`}>
      <div className='mb-6 relative'>
        <SearchInput
          ref={searchInputRef}
          placeholder={blockSettings.placeholder_text || 'Search'}
          onSearch={handleSearch}
          isLoading={false}
          maintainFocus={false}
          onFocus={handleOpenSearch}
          onClick={handleOpenSearch}
        />
      </div>
    </div>
  );
};
